var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.platforms.length
        ? _c("el-alert", {
            staticClass: "alert",
            attrs: {
              title:
                "请先在“服务商配置”页保存配置，并在微信开放平台配置回调地址。",
              type: "warning",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        { staticClass: "filters", attrs: { inline: "" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "服务商" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  on: { change: _vm.search },
                  model: {
                    value: _vm.query.platformId,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "platformId", $$v)
                    },
                    expression: "query.platformId",
                  },
                },
                _vm._l(_vm.platforms, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.platformName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "小程序" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "名称或AppID" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search($event)
                  },
                },
                model: {
                  value: _vm.query.keyword,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.query,
                      "keyword",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "query.keyword",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "授权状态" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "全部" },
                  model: {
                    value: _vm.query.authorizationStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "authorizationStatus", $$v)
                    },
                    expression: "query.authorizationStatus",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "已授权", value: "AUTHORIZED" },
                  }),
                  _c("el-option", {
                    attrs: { label: "未授权/已取消", value: "UNAUTHORIZED" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.search } },
                [_vm._v("查询")]
              ),
              _c("el-button", { on: { click: _vm.reset } }, [_vm._v("重置")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { data: _vm.list, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "appName", label: "系统小程序", "min-width": "150" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "appId", label: "AppID", "min-width": "185" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "branchName",
              label: "Git分支",
              "min-width": "150",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "授权状态", width: "105" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            scope.row.authorizationStatus === "AUTHORIZED"
                              ? "success"
                              : "info",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            scope.row.authorizationStatus === "AUTHORIZED"
                              ? "已授权"
                              : "未授权"
                          )
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "权限集", width: "90" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        scope.row.permissionStatus === "GRANTED"
                          ? "已获取"
                          : "-"
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "principalName",
              label: "主体名称",
              "min-width": "150",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "authorizationTime",
              label: "授权时间",
              "min-width": "165",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "180", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.authorizationStatus === "AUTHORIZED"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["admin:wechat:open-platform:authorize"],
                            expression:
                              "['admin:wechat:open-platform:authorize']",
                          },
                        ],
                        attrs: {
                          type: "text",
                          disabled: !_vm.query.platformId,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.authorize(scope.row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.authorizationStatus === "AUTHORIZED"
                                ? "重新授权"
                                : "去授权"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
              "current-page": _vm.query.page,
              "page-size": _vm.query.limit,
              "page-sizes": [10, 20, 50],
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.query, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.query, "page", $event)
              },
              "current-change": _vm.pageChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "授权小程序详情",
            visible: _vm.detailVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
            },
            [
              _vm.detail.appId
                ? _c(
                    "div",
                    { staticClass: "detail-header" },
                    [
                      _c("el-avatar", {
                        attrs: {
                          size: 56,
                          src: _vm.detail.headImg || _vm.detail.appLogo,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.detail.nickName || _vm.detail.appName)
                          ),
                        ]),
                        _c("div", [_vm._v(_vm._s(_vm.detail.appId))]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:wechat:open-platform:authorize"],
                              expression:
                                "['admin:wechat:open-platform:authorize']",
                            },
                          ],
                          attrs: {
                            type: "primary",
                            plain: "",
                            loading: _vm.syncing,
                          },
                          on: { click: _vm.syncDetail },
                        },
                        [_vm._v("同步微信信息")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.detail.appId
                ? _c(
                    "el-row",
                    { staticClass: "detail-grid", attrs: { gutter: 16 } },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("label", [_vm._v("主体名称")]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.detail.principalName || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("label", [_vm._v("原始ID")]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.detail.originalId || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("label", [_vm._v("授权时间")]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.detail.authorizationTime || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("label", [_vm._v("Token有效期")]),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.detail.accessTokenExpireTime || "-")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("label", [_vm._v("最近同步")]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.detail.lastSyncTime || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("label", [_vm._v("授权状态")]),
                        _c(
                          "div",
                          [
                            _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("已授权"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.detail.appId ? _c("h4", [_vm._v("已授权权限集")]) : _vm._e(),
              _vm._v(" "),
              _vm.detail.appId
                ? _c(
                    "div",
                    { staticClass: "permission-tags" },
                    [
                      _vm._l(
                        _vm.detail.grantedPermissions || [],
                        function (item) {
                          return _c(
                            "el-tag",
                            { key: item.id, attrs: { size: "small" } },
                            [
                              _vm._v(
                                _vm._s(item.id) + " - " + _vm._s(item.name)
                              ),
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      !_vm.detail.grantedPermissions ||
                      !_vm.detail.grantedPermissions.length
                        ? _c("span", [_vm._v("暂无权限")])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.detail.appId ? _c("h4", [_vm._v("业务能力矩阵")]) : _vm._e(),
              _vm._v(" "),
              _vm.detail.appId
                ? _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.detail.capabilityMatrix || [],
                        border: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "能力",
                          "min-width": "210",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "所需权限集", "min-width": "140" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        scope.row.requiredPermissionIds || []
                                      ).join(", ")
                                    )
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          952906151
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: scope.row.granted
                                          ? "success"
                                          : "info",
                                        size: "small",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.granted
                                            ? "已授权"
                                            : "未授权"
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          840946929
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }